import type {Dispatch} from 'react'
import {Button, Dialog, DialogTrigger, Popover} from 'react-aria-components'
import {Range} from 'react-range'

import ChevronDownSvg from '@/assets/icons/chevron-down.svg?react'
import PrimaryButton from '@/components/PrimaryButton/PrimaryButton'
import VisuallyHidden from '@/utils/a11y/VisuallyHidden'

import style from './FilterDuration.module.scss'

interface Props {
  maxDuration: number | null
  setMaxDuration: Dispatch<number | null>
  maximumDuration: number
  minimumDuration: number
}

export default memo<Props>(function FilterDuration(props) {
  const valueText = props.maxDuration ? `${props.maxDuration} hr` : 'any'
  const valueTextHelper = props.maxDuration ? 'under ' : ''

  return (
    <DialogTrigger>
      <Button className={style.Button}>
        <div className={style.Value}>
          <span>
            Duration<VisuallyHidden>&nbsp;filter</VisuallyHidden>
            {props.maxDuration ? (
              <>
                :&nbsp;under&nbsp;
                {props.maxDuration} hr
              </>
            ) : (
              <VisuallyHidden>: any</VisuallyHidden>
            )}
          </span>
        </div>
        <span aria-hidden className={style.Chevron}>
          <ChevronDownSvg
            className={style.ChevronIcon}
            width={12}
            height={16}
            viewBox='0 0 24 24'
            aria-hidden
          />
        </span>
      </Button>
      <Popover className={style.Popover}>
        <Dialog className={style.Dialog}>
          <div className={style.ValueText} aria-hidden>
            Flight duration:{' '}
            <span>
              {valueTextHelper}
              {valueText}
            </span>
          </div>
          <Range
            label='Max duration'
            step={1}
            min={props.minimumDuration}
            max={props.maximumDuration}
            values={[props.maxDuration ?? props.minimumDuration]}
            onChange={values => {
              if (values[0] === undefined) return
              props.setMaxDuration(values[0])
            }}
            renderTrack={({props, children}) => (
              <div {...props} style={props.style} className={style.Track}>
                {children}
              </div>
            )}
            renderThumb={({props}) => (
              <div {...props} key={props.key} style={props.style} className={style.Thumb} />
            )}
            aria-valuetext={valueText}
          />
          <div className={style.ClearButtonContainer}>
            <PrimaryButton
              size='sm'
              className={style.ClearButton}
              onPress={() => {
                props.setMaxDuration(null)
              }}
            >
              Clear
            </PrimaryButton>
          </div>
        </Dialog>
      </Popover>
    </DialogTrigger>
  )
})
